module.exports = __webpack_public_path__ + "static/media/Safari.ea22f01a.png";